import RouteComponent from "./RouteComponent";
import RouteBack from "./RouteBack";
import RouteFront from "./RouteFront";

const route = [...RouteComponent, ...RouteBack, ...RouteFront];

export default route;
